export default "__VITE_ASSET__d997da5a__"